import React from 'react';
import styles from './OutOfStock.module.css';
import backImg from '../../../../assets/images/Fireboard/back2_red.png';

const OutOfStock = (props) => {
  const { onOutOfStockItemsPress, dismissPopup } = props;

  return (
    <div className={styles.container}>
      <div className={styles.backButton} onClick={dismissPopup}>
        <img src={backImg} className={styles.backImage} alt="" />
      </div>
      <div className={styles.wrapper}>
        <div className={styles.heading}>Please select the menu type to proceed</div>
        <div className={styles.btnWrapper}>
          <button className={styles.btns} onClick={() => onOutOfStockItemsPress('items', true)}>ITEMS</button>
          <button className={styles.btns} onClick={() => onOutOfStockItemsPress('modifiers', true)}>MODIFIERS</button>
        </div>
      </div>
    </div>
  );
}

export default OutOfStock;
